export default {
    xs: '5px',
    sm: '10px',
    md: '20px',
    lg: '30px',
    xl: '40px',
    xxl: '50px',
    xxxl: '70px',
}
